import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';
import DiagnosisCard from './DiagnosisCard';
import type {
  DiagnosisWithReasoning,
  PrimaryDiagnosis,
  OEType,
  SeverityType,
} from '../types/codingData.types';

interface SortableDiagnosisCardProps {
  id: string;
  diagnosis: DiagnosisWithReasoning | PrimaryDiagnosis;
  variant: 'primary' | 'secondary';
  onOpenModal?: (dataType: string) => void;
  position?: number;
  onEdit?: () => void;
  onRemove?: () => void;
  isCompliant?: boolean;
  onFieldChange?: (fields: {
    oe?: OEType;
    onset_date?: string | null;
    severity?: SeverityType;
  }) => void;
}

const SortableDiagnosisCard: React.FC<SortableDiagnosisCardProps> = ({
  id,
  ...props
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 50 : 'auto',
  };

  return (
    <div ref={setNodeRef} style={style} className='relative group'>
      {/* Drag Handle */}
      <div
        {...attributes}
        {...listeners}
        className='absolute -left-3.5 top-1/2 -translate-y-1/2 cursor-grab active:cursor-grabbing z-10 p-1.5 hover:bg-primary-50 rounded-md transition-opacity opacity-0 group-hover:opacity-100'
        title='Drag to reorder'
      >
        <GripVertical className='w-4 h-4 text-primary-600' />
      </div>

      {/* Diagnosis Card */}
      <DiagnosisCard {...props} />
    </div>
  );
};

export default SortableDiagnosisCard;
